import {Features, FeatureService} from './index';

declare global {
    interface Window {
        features: Features;
    }
}

export class DefaultFeatureService implements FeatureService {
    private get _features(): Features {
        return window.features || {};
    }

    private set _features(features: Features) {
        window.features = {...features};
    }

    getList(): Features {
        return this._features;
    }

    isEnabled(name: string): boolean {
        this.checkIfFeatureExists(name);

        return this._features[name];
    }

    isDisabled(name: string): boolean {
        return !this.isEnabled(name);
    }

    enable(name: string): void {
        this.setFeatureValue(name, true);
    }

    disable(name: string): void {
        this.setFeatureValue(name, false);
    }

    private setFeatureValue(name: string, value: boolean) {
        this._features = {
            ...this._features,
            [name]: value,
        };
    }

    private checkIfFeatureExists(name: string) {
        // eslint-disable-next-line no-prototype-builtins
        if (!this._features.hasOwnProperty(name)) {
            throw new Error(`FeatureService : unknow feature name ${name}`);
        }
    }
}
